import { useMemo, useState } from 'react'
import { Box } from '@mui/material'
import { Form, Formik } from 'formik'
import { t } from 'i18next'

import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import ButtonSecondary from 'src/components/shared/ui/ButtonSecondary'
import {
  initialValues,
  validationSchema
} from 'src/components/views/EscritosLexnet/components/shared/components/Intervinientes/components/RepresentanteLegal/types'
import { FormField } from 'src/enums/Form'
import { useFetchTipoVia } from 'src/hooks/fetch/useCatalogoGeneralFetch'
import { RepresentanteLegal } from 'src/interfaces/EscritosLegales'
import RequiredText from '../../../RequiredText'
import RepresentanteLegalFormFields from './RepresentanteLegalFormFields'

type Props = {
  closeDialog: () => void
  getFormValues: (values: RepresentanteLegal) => void
  formValues?: RepresentanteLegal | null
}
export default function FormRepresentanteLegal({
  closeDialog,
  getFormValues,
  formValues
}: Props): JSX.Element {
  const [disabledAddBtn, setDisabledAddBtn] = useState(false)
  const [validateAfterSubmit, setValidateAfterSubmit] = useState(false)
  const { data: tipoViaData } = useFetchTipoVia([FormField.INTERVINIENTE_DIRECCION_TIPO_VIA])

  const representanteValidationSchema = useMemo(() => validationSchema(tipoViaData), [tipoViaData])

  function handleSubmit(values: RepresentanteLegal): void {
    setDisabledAddBtn(true)
    getFormValues(values)
    closeDialog()
  }

  return (
    <>
      <Formik
        initialValues={formValues ?? initialValues}
        form="formRepresentanteLegal"
        onSubmit={handleSubmit}
        validationSchema={representanteValidationSchema}
        validateOnMount={false}
        validateOnBlur={validateAfterSubmit}
        validateOnChange={validateAfterSubmit}
      >
        {({ submitForm, handleSubmit }) => (
          <Form
            onSubmit={event => {
              setValidateAfterSubmit(true)
              handleSubmit(event)
            }}
          >
            <Box sx={{ marginTop: '12px' }}>
              <RequiredText />
            </Box>
            <RepresentanteLegalFormFields />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <ButtonPrimaryOutlined onClick={closeDialog}>
                {t('actions.cancel')}
              </ButtonPrimaryOutlined>
              <ButtonSecondary type="submit" onClick={submitForm} disabled={disabledAddBtn}>
                {formValues ? t('actions.save') : t('actions.add')}
              </ButtonSecondary>
            </Box>
          </Form>
        )}
      </Formik>
    </>
  )
}
